export var StorageType;
(function (StorageType) {
    StorageType["AmazonS3"] = "amazonS3";
    StorageType["AzureBlobStorage"] = "azureBlobStorage";
    StorageType["MsSharePoint"] = "msSharePoint";
    StorageType["Sftp"] = "sftp";
})(StorageType || (StorageType = {}));
//# sourceMappingURL=data-export-storage-type.js.map